import React from "react";
import facebookIcon from "../assets/icons/facebook.svg";
import instagramIcon from "../assets/icons/instagram.svg";
import linkedinIcon from "../assets/icons/linkedin.svg";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
  return (
    <div className="w-full h-auto md:h-[80%]">
      {/* Logo & Social Section */}
      <div className="pl-2 pt-6 flex justify-between items-center md:mx-[35px] md:my-10 md:p-0">
        {/* Logo */}
        <div className="pl-4 flex items-center space-x-2">
          <img
            src="MM Logo.jpg"
            alt="MM Coding Lingo Logo"
            className="w-30 md:w-[100%] h-8 md:h-16"
          />
        </div>

        {/* Social Icons */}
        <div className="flex space-x-3 mr-[4%]">
          <a
            href="https://www.facebook.com/MMDIGITALSCHOOL/?_rdc=1&_rdr#"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={facebookIcon}
              alt="Facebook icon"
              className="w-6 h-6 hover:opacity-80 transition"
            />
          </a>

          <a
            href="https://www.instagram.com/m.m.institute/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={instagramIcon}
              alt="Instagram icon"
              className="w-6 h-6 hover:opacity-80 transition"
            />
          </a>

          <a
            href="https://www.linkedin.com/company/mmcodinglingo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={linkedinIcon}
              alt="LinkedIn icon"
              className="w-6 h-6 hover:opacity-80 transition"
            />
          </a>
        </div>
      </div>

      {/* Divider */}
      <hr className="ml-8 md:ml-[35px] border-gray-300 mr-[5%] md:mr-[37px] my-6" />

      {/* Bottom Section */}
      <div className="mb-0 flex flex-col md:flex-row justify-center md:justify-between items-center md:mb-8 text-center md:text-left">
        <div className="ml-2 md:ml-[35px] text-black font-roboto">
          <span>
            MM Coding Lingo © 2025. All rights reserved.
          </span>
        </div>

        {/* Navigation Links */}
        <nav className="hidden md:flex space-x-6 font-roboto md:mr-[37px]">
          <HashLink smooth to="/#home" className="text-[#6C6C6C] hover:text-red-700">Home</HashLink>
          <HashLink smooth to="/#about" className="text-[#6C6C6C] hover:text-red-700">About</HashLink>
          <HashLink smooth to="/#Services" className="text-[#6C6C6C] hover:text-red-700">Services</HashLink>
          <HashLink smooth to="/#Work" className="text-[#6C6C6C] hover:text-red-700">Our Work</HashLink>
          <HashLink smooth to="/#client" className="text-[#6C6C6C] hover:text-red-700">Client Testimonials</HashLink>
        </nav>
      </div>
    </div>
  );
}
